import React from "react";

const ProjectsStats = () => {
    return (
        <div className="font-medium text-base md:text-xl w-full text-white flex flex-col items-center md:flex-row space-y-2 md:space-y-0 justify-evenly">
            <div>
                <span>20</span> Teams
            </div>
            <div>
                <span>40+</span> Contributors
            </div>
            <div>
                <span>20+</span> Projects
            </div>
        </div>
    );
};

export default ProjectsStats;
